<template>
  <div class="container">
    <p class="titleMain">Запланированные презентации</p>

    <p v-if="presentationsList.length == 0" style="text-align: center">
      Нет запланированных презентаций
    </p>

    <presentationItem
      v-for="(client, index) in presentationsList"
      :key="index"
      :clientInfo="client"
      @deletePresentationItem="deleteItem"
    >
    </presentationItem>
  </div>
</template>
<script>
import presentationItem from "@/components/presentation/presentationItem";
export default {
  components: { presentationItem },
  data: function () {
    return {
      presentationsList: [],
    };
  },
  methods: {
    startComponent() {
      this.$store.dispatch("GET_PRESENTATION_LIST").then((resp) => {
        if(resp.data.status != "success"){
          this.$makeToast(
            "Упс!",
            "danger",
            "Почему-то с сервера не пришел список презентаций:(",
            5000);
        } else {
          this.presentationsList = resp.data.data.filter(x=> x.completed != 1);
        }

      });
    },
    deleteItem(){
      this.startComponent()
    }
  },
  created: function () {
     this.startComponent()
  },
};
</script>
